import { put } from './secure_fetch.js';

/**
 * Sends visual search crop coordinates to the backend and returns matching font variations.
 */
export const putVisualSearch = async (opaqueId: string, params: Record<string, unknown>, signal?: AbortSignal) => {
  const response = await put(`/fonts/vs/${opaqueId}`, {
    body: JSON.stringify(params),
    signal
  });

  if (!response.ok) {
    throw new Error(`Visual search request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
};
